<!--     
    Copyright (c) 2022 nVipani Technology Solutions Private Limited.
    All rights reserved.
  -->
<div class="container" fxLayout="row" fxLayoutAlign="space-between start">
  <div>
    <span class="size-text">Size-{{ item.value }}</span>
    <span *ngIf="isPriceDisplay" class="size-text price currency"
      >({{
        this.slotService.getFormattedCurrency(item.price?.MRP?.value)
      }})</span
    >
  </div>
  <div *ngIf="!isWishList">
    <span class="number-picker">
      <span (click)="decreaseQuantity()" class="minus">-</span>
      <input
        disabled
        class="text-input"
        type="text"
        [(ngModel)]="value"
        value="value"
      />
      <span (click)="increaseQuantity()" class="plus">+</span>
    </span>
  </div>

  <div
    fxLayout="row"
    fxLayoutAlign="start center"
    *ngIf="isWishList && value"
    (click)="decreaseQuantity()"
    fxLayoutGap="0.5em"
  >
    <img src="{{ blackFavourite }}" />
    <h5 class="nvc-font-weight-normal">Remove from Wishlist</h5>
  </div>
  <div
    fxLayout="row"
    fxLayoutAlign="start center"
    fxLayoutGap="0.5em"
    *ngIf="isWishList && !value"
    (click)="increaseQuantity()"
  >
    <img src="{{ blueFavourite }}" />
    <h5 class="nvc-font-weight-normal">Add to Wishlist</h5>
  </div>
</div>
